export default __webpack_public_path__ + "static/media/Screenshot (498).d05edf4a.png";